// import React, { useState, useEffect } from 'react';
// import {
//     FaEye, FaSearch, FaSpinner, FaTimes,
//     FaChevronDown, FaChevronUp, FaUsers,
//     FaClipboardList, FaCalendarAlt, FaMapMarkerAlt,
//     FaMoneyBillWave, FaCheckCircle, FaClock,
//     FaBuilding, FaUser, FaEnvelope, FaPhone,
//     FaRupeeSign, FaUtensils, FaTruck
// } from 'react-icons/fa';
// import { getAllEnquiries } from '../../../Servicefile/salesService';
// import axios from 'axios';

// const SalseQuotation = () => {
//     // ============================================
//     // STATE
//     // ============================================
//     const [enquiries, setEnquiries] = useState([]);
//     const [filteredEnquiries, setFilteredEnquiries] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [loadingQuotations, setLoadingQuotations] = useState(false);
//     const [searchTerm, setSearchTerm] = useState('');
//     const [expandedId, setExpandedId] = useState(null);
//     const [quotationsMap, setQuotationsMap] = useState({});
//     const [expandedQuotation, setExpandedQuotation] = useState(null);

//     // Stats
//     const [stats, setStats] = useState({
//         total: 0,
//         quoted: 0,
//         pending: 0
//     });

//     // ============================================
//     // API CALLS
//     // ============================================
//     const fetchQuotations = async () => {
//         setLoading(true);
//         try {
//             const data = await getAllEnquiries();
            
//             const quotedData = (data || []).filter(enquiry => 
//                 enquiry.adminId !== null && 
//                 enquiry.adminId !== undefined &&
//                 enquiry.leadStatus === 'PAYMENT_RECEIVED'
//             );
            
//             const sortedData = quotedData.sort((a, b) => {
//                 const dateA = new Date(a.createdAt);
//                 const dateB = new Date(b.createdAt);
//                 return dateB - dateA;
//             });
            
//             setEnquiries(sortedData);
//             setFilteredEnquiries(sortedData);
//             calculateStats(sortedData);
//         } catch (error) {
//             console.error('Error fetching quotations:', error);
//             alert('Failed to fetch quotations');
//         } finally {
//             setLoading(false);
//         }
//     };

//     const fetchQuotationsByLeadId = async (leadId) => {
//         if (quotationsMap[leadId]) {
//             return;
//         }

//         setLoadingQuotations(true);
//         try {
//             const token = localStorage.getItem("authToken");
//             const response = await axios.get(
//                 `https://backend.maamaas.com/catering/api/user/lead/quotations/${leadId}/`,
//                 {
//                     headers: {
//                         'Authorization': `Bearer ${token}`
//                     }
//                 }
//             );

//             if (response.data.success) {
//                 setQuotationsMap(prev => ({
//                     ...prev,
//                     [leadId]: response.data.data || []
//                 }));
//             } else {
//                 setQuotationsMap(prev => ({
//                     ...prev,
//                     [leadId]: []
//                 }));
//             }
//         } catch (error) {
//             console.error('Error fetching quotations:', error);
//             setQuotationsMap(prev => ({
//                 ...prev,
//                 [leadId]: []
//             }));
//         } finally {
//             setLoadingQuotations(false);
//         }
//     };

//     // ============================================
//     // CALCULATE STATS
//     // ============================================
//     const calculateStats = (data) => {
//         const total = data.length;
//         const quoted = data.filter(e => e.leadStatus === 'PAYMENT_RECEIVED').length;
//         const pending = data.filter(e => e.leadStatus !== 'PAYMENT_RECEIVED').length;
//         setStats({ total, quoted, pending });
//     };

//     // ============================================
//     // FILTER
//     // ============================================
//     const handleSearch = (e) => {
//         const term = e.target.value.toLowerCase();
//         setSearchTerm(term);
        
//         if (term.trim() === '') {
//             setFilteredEnquiries(enquiries);
//         } else {
//             const filtered = enquiries.filter(enquiry =>
//                 (enquiry.fullName || '').toLowerCase().includes(term) ||
//                 (enquiry.email || '').toLowerCase().includes(term) ||
//                 (enquiry.companyName || '').toLowerCase().includes(term) ||
//                 (enquiry.city || '').toLowerCase().includes(term) ||
//                 (enquiry.enquiryId || enquiry.id || '').toString().includes(term)
//             );
//             setFilteredEnquiries(filtered);
//         }
//     };

//     const clearSearch = () => {
//         setSearchTerm('');
//         setFilteredEnquiries(enquiries);
//     };

//     // ============================================
//     // TOGGLE EXPAND
//     // ============================================
//     const toggleExpand = (leadId) => {
//         if (expandedId === leadId) {
//             setExpandedId(null);
//             setExpandedQuotation(null);
//         } else {
//             setExpandedId(leadId);
//             setExpandedQuotation(null);
//             fetchQuotationsByLeadId(leadId);
//         }
//     };

//     const toggleQuotationExpand = (quotationId) => {
//         setExpandedQuotation(expandedQuotation === quotationId ? null : quotationId);
//     };

//     // ============================================
//     // FORMAT HELPERS
//     // ============================================
//     const formatDate = (dateStr) => {
//         if (!dateStr) return '-';
//         try {
//             const date = new Date(dateStr);
//             return date.toLocaleDateString('en-IN', {
//                 day: '2-digit',
//                 month: 'short',
//                 year: 'numeric'
//             });
//         } catch {
//             return dateStr;
//         }
//     };

//     const formatCurrency = (amount) => {
//         if (!amount) return '₹0';
//         return `₹${Number(amount).toLocaleString()}`;
//     };

//     const getStatusBadge = (status) => {
//         if (status === 'PAYMENT_RECEIVED') {
//             return (
//                 <span style={{
//                     display: 'inline-flex',
//                     alignItems: 'center',
//                     gap: '4px',
//                     padding: '4px 12px',
//                     borderRadius: '20px',
//                     fontSize: '11px',
//                     fontWeight: 600,
//                     background: '#D1FAE5',
//                     color: '#065F46'
//                 }}>
//                     <FaCheckCircle size={12} /> Quoted
//                 </span>
//             );
//         }
//         return (
//             <span style={{
//                 display: 'inline-flex',
//                 alignItems: 'center',
//                 gap: '4px',
//                 padding: '4px 12px',
//                 borderRadius: '20px',
//                 fontSize: '11px',
//                 fontWeight: 600,
//                 background: '#FEF3C7',
//                 color: '#92400E'
//             }}>
//                 <FaClock size={12} /> Pending
//             </span>
//         );
//     };

//     const getQuotationStatusBadge = (status) => {
//         const statusMap = {
//             'SUBMITTED': { bg: '#DBEAFE', color: '#1E40AF', label: 'Submitted' },
//             'APPROVED': { bg: '#D1FAE5', color: '#065F46', label: 'Approved' },
//             'REJECTED': { bg: '#FEE2E2', color: '#991B1B', label: 'Rejected' },
//             'PENDING': { bg: '#FEF3C7', color: '#92400E', label: 'Pending' }
//         };
//         const info = statusMap[status] || statusMap['PENDING'];
//         return (
//             <span style={{
//                 display: 'inline-flex',
//                 alignItems: 'center',
//                 gap: '4px',
//                 padding: '3px 10px',
//                 borderRadius: '16px',
//                 fontSize: '11px',
//                 fontWeight: 500,
//                 background: info.bg,
//                 color: info.color
//             }}>
//                 {info.label}
//             </span>
//         );
//     };

//     // ============================================
//     // EFFECTS
//     // ============================================
//     useEffect(() => {
//         fetchQuotations();
//     }, []);

//     // ============================================
//     // RENDER
//     // ============================================
//     return (
//         <div style={containerStyle}>
//             {/* Header */}
//             <div style={headerStyle}>
//                 <div style={headerLeftStyle}>
//                     <div style={headerIconStyle}>
//                         <FaClipboardList size={22} />
//                     </div>
//                     <div>
//                         <h2 style={titleStyle}>Sales Quotations</h2>
//                         <p style={subtitleStyle}>Manage and track all quoted enquiries</p>
//                     </div>
//                 </div>
//             </div>

//             {/* Stats Cards */}
//             <div style={statsContainerStyle}>
//                 <div style={statCardStyle}>
//                     <div style={{ ...statIconWrapperStyle, background: '#EEF2FF' }}>
//                         <FaClipboardList style={{ color: '#4F46E5' }} size={20} />
//                     </div>
//                     <div>
//                         <div style={statNumberStyle}>{stats.total}</div>
//                         <div style={statLabelStyle}>Total Quoted</div>
//                     </div>
//                 </div>
//                 <div style={statCardStyle}>
//                     <div style={{ ...statIconWrapperStyle, background: '#D1FAE5' }}>
//                         <FaCheckCircle style={{ color: '#059669' }} size={20} />
//                     </div>
//                     <div>
//                         <div style={statNumberStyle}>{stats.quoted}</div>
//                         <div style={statLabelStyle}>Quoted</div>
//                     </div>
//                 </div>
//                 <div style={statCardStyle}>
//                     <div style={{ ...statIconWrapperStyle, background: '#FEF3C7' }}>
//                         <FaClock style={{ color: '#D97706' }} size={20} />
//                     </div>
//                     <div>
//                         <div style={statNumberStyle}>{stats.pending}</div>
//                         <div style={statLabelStyle}>Pending</div>
//                     </div>
//                 </div>
//             </div>

//             {/* Search */}
//             <div style={searchFilterContainerStyle}>
//                 <div style={searchContainerStyle}>
//                     <FaSearch style={searchIconStyle} />
//                     <input
//                         type="text"
//                         placeholder="Search by name, email, company, city..."
//                         value={searchTerm}
//                         onChange={handleSearch}
//                         style={searchInputStyle}
//                     />
//                     {searchTerm && (
//                         <button onClick={clearSearch} style={clearSearchButtonStyle}>
//                             <FaTimes size={14} />
//                         </button>
//                     )}
//                 </div>
//                 <div style={resultCountStyle}>
//                     {filteredEnquiries.length} result{filteredEnquiries.length !== 1 && 's'}
//                 </div>
//             </div>

//             {/* Quotation Cards - Auto Height Container */}
//             <div style={cardsContainerStyle}>
//                 {loading ? (
//                     <div style={loadingStyle}>
//                         <FaSpinner style={{ animation: 'spin 1s linear infinite' }} size={32} color="#4F46E5" />
//                         <p>Loading quotations...</p>
//                     </div>
//                 ) : filteredEnquiries.length === 0 ? (
//                     <div style={emptyStateStyle}>
//                         <div style={emptyStateContentStyle}>
//                             <FaClipboardList size={48} color="#D1D5DB" />
//                             <p style={emptyStateTextStyle}>No quotations found</p>
//                             <span style={emptyStateSubtextStyle}>
//                                 {searchTerm ? 'Try adjusting your search terms' : 'No enquiries with quotations available'}
//                             </span>
//                         </div>
//                     </div>
//                 ) : (
//                     filteredEnquiries.map((enquiry) => {
//                         const isExpanded = expandedId === (enquiry.id || enquiry.enquiryId);
//                         const leadQuotations = quotationsMap[enquiry.id || enquiry.enquiryId] || [];
//                         const totalPlates = (enquiry.vegPlates || 0) + (enquiry.nonVegPlates || 0) + (enquiry.mixedPlates || 0);
//                         const isLoadingQuotations = loadingQuotations && isExpanded && !quotationsMap[enquiry.id || enquiry.enquiryId];
                        
//                         return (
//                             <div key={enquiry.id || enquiry.enquiryId} style={cardWrapperStyle}>
//                                 {/* Card Header - Always visible */}
//                                 <div 
//                                     style={cardHeaderStyle}
//                                     onClick={() => toggleExpand(enquiry.id || enquiry.enquiryId)}
//                                 >
//                                     <div style={cardHeaderLeftStyle}>
//                                         <div style={avatarStyle}>
//                                             {(enquiry.fullName || '?')[0].toUpperCase()}
//                                         </div>
//                                         <div>
//                                             <div style={customerNameStyle}>{enquiry.fullName || 'Unknown'}</div>
//                                             <div style={customerDetailStyle}>
//                                                 {enquiry.companyName || 'No company'} • {enquiry.city || 'No city'}
//                                             </div>
//                                         </div>
//                                     </div>
//                                     <div style={cardHeaderRightStyle}>
//                                         <div style={amountStyle}>{formatCurrency(enquiry.budget)}</div>
//                                         <div>{getStatusBadge(enquiry.leadStatus)}</div>
//                                         <div style={expandIconStyle}>
//                                             {isExpanded ? <FaChevronUp size={16} /> : <FaChevronDown size={16} />}
//                                         </div>
//                                     </div>
//                                 </div>

//                                 {/* Card Body - Expandable */}
//                                 {isExpanded && (
//                                     <div style={cardBodyStyle}>
//                                         {isLoadingQuotations ? (
//                                             <div style={loadingQuotationsStyle}>
//                                                 <FaSpinner style={{ animation: 'spin 1s linear infinite' }} size={24} color="#4F46E5" />
//                                                 <p>Loading quotations...</p>
//                                             </div>
//                                         ) : leadQuotations.length === 0 ? (
//                                             <div style={noQuotationsStyle}>
//                                                 <p>No quotations found for this lead</p>
//                                             </div>
//                                         ) : (
//                                             <div style={quotationsListStyle}>
//                                                 {leadQuotations.map((quotation, index) => (
//                                                     <div 
//                                                         key={quotation.quotationId || index} 
//                                                         style={quotationCardStyle}
//                                                     >
//                                                         {/* Quotation Header */}
//                                                         <div 
//                                                             style={quotationHeaderStyle}
//                                                             onClick={() => toggleQuotationExpand(quotation.quotationId)}
//                                                         >
//                                                             <div style={quotationHeaderLeftStyle}>
//                                                                 <div style={vendorIconStyle}>
//                                                                     <FaBuilding size={16} />
//                                                                 </div>
//                                                                 <div>
//                                                                     <div style={vendorNameStyle}>{quotation.vendorName || 'Unknown Vendor'}</div>
//                                                                     <div style={quotationMetaStyle}>
//                                                                         {getQuotationStatusBadge(quotation.status)}
//                                                                         <span style={quotationDateStyle}>
//                                                                             {formatDate(quotation.createdAt)}
//                                                                         </span>
//                                                                     </div>
//                                                                 </div>
//                                                             </div>
//                                                             <div style={quotationHeaderRightStyle}>
//                                                                 <div style={quotedAmountStyle}>{formatCurrency(quotation.quotedAmount)}</div>
//                                                                 <div style={expandIconStyle}>
//                                                                     {expandedQuotation === quotation.quotationId ? 
//                                                                         <FaChevronUp size={14} /> : 
//                                                                         <FaChevronDown size={14} />
//                                                                     }
//                                                                 </div>
//                                                             </div>
//                                                         </div>

//                                                         {/* Quotation Details - Expandable */}
//                                                         {expandedQuotation === quotation.quotationId && (
//                                                             <div style={quotationDetailStyle}>
//                                                                 <div style={quotationGridStyle}>
//                                                                     {/* Pricing Details */}
//                                                                     <div style={quotationSectionStyle}>
//                                                                         <h4 style={quotationSectionTitleStyle}>Pricing Details</h4>
//                                                                         <div style={detailRowStyle}>
//                                                                             <span style={detailLabelStyle}>Base Amount:</span>
//                                                                             <span style={detailValueStyle}>{formatCurrency(quotation.baseAmount)}</span>
//                                                                         </div>
//                                                                         <div style={detailRowStyle}>
//                                                                             <span style={detailLabelStyle}>Veg/Plate:</span>
//                                                                             <span style={detailValueStyle}>{formatCurrency(quotation.vegPerPlatePrice)}</span>
//                                                                         </div>
//                                                                         <div style={detailRowStyle}>
//                                                                             <span style={detailLabelStyle}>Non-Veg/Plate:</span>
//                                                                             <span style={detailValueStyle}>{formatCurrency(quotation.nonVegPerPlatePrice)}</span>
//                                                                         </div>
//                                                                         <div style={detailRowStyle}>
//                                                                             <span style={detailLabelStyle}>Mixed/Plate:</span>
//                                                                             <span style={detailValueStyle}>{formatCurrency(quotation.mixedPerPlatePrice)}</span>
//                                                                         </div>
//                                                                         <div style={detailRowStyle}>
//                                                                             <span style={detailLabelStyle}>Total Plates:</span>
//                                                                             <span style={detailValueStyle}>{quotation.totalPlates}</span>
//                                                                         </div>
//                                                                         <div style={detailRowStyle}>
//                                                                             <span style={detailLabelStyle}>Platform Fee:</span>
//                                                                             <span style={detailValueStyle}>{formatCurrency(quotation.platformFee)}</span>
//                                                                         </div>
//                                                                         <div style={detailRowStyle}>
//                                                                             <span style={detailLabelStyle}>Delivery Fee:</span>
//                                                                             <span style={detailValueStyle}>{formatCurrency(quotation.deliveryFee)}</span>
//                                                                         </div>
//                                                                         <div style={detailRowStyle}>
//                                                                             <span style={detailLabelStyle}>Grand Total:</span>
//                                                                             <span style={{ ...detailValueStyle, fontWeight: 700, color: '#059669' }}>
//                                                                                 {formatCurrency(quotation.grandTotal)}
//                                                                             </span>
//                                                                         </div>
//                                                                     </div>

//                                                                     {/* Vendor Details */}
//                                                                     <div style={quotationSectionStyle}>
//                                                                         <h4 style={quotationSectionTitleStyle}>Vendor Details</h4>
//                                                                         <div style={detailRowStyle}>
//                                                                             <span style={detailLabelStyle}>Vendor:</span>
//                                                                             <span style={detailValueStyle}>{quotation.vendorName}</span>
//                                                                         </div>
//                                                                         <div style={detailRowStyle}>
//                                                                             <span style={detailLabelStyle}>City:</span>
//                                                                             <span style={detailValueStyle}>{quotation.vendorCity || '-'}</span>
//                                                                         </div>
//                                                                         <div style={detailRowStyle}>
//                                                                             <span style={detailLabelStyle}>State:</span>
//                                                                             <span style={detailValueStyle}>{quotation.vendorState || '-'}</span>
//                                                                         </div>
//                                                                         <div style={detailRowStyle}>
//                                                                             <span style={detailLabelStyle}>Address:</span>
//                                                                             <span style={detailValueStyle}>{quotation.vendorFullAddress || '-'}</span>
//                                                                         </div>
//                                                                         <div style={detailRowStyle}>
//                                                                             <span style={detailLabelStyle}>Distance:</span>
//                                                                             <span style={detailValueStyle}>{quotation.distanceInKm ? `${quotation.distanceInKm} km` : '-'}</span>
//                                                                         </div>
//                                                                     </div>

//                                                                     {/* Event Details */}
//                                                                     <div style={quotationSectionStyle}>
//                                                                         <h4 style={quotationSectionTitleStyle}>Event Details</h4>
//                                                                         <div style={detailRowStyle}>
//                                                                             <span style={detailLabelStyle}>Event:</span>
//                                                                             <span style={detailValueStyle}>{quotation.event || '-'}</span>
//                                                                         </div>
//                                                                         <div style={detailRowStyle}>
//                                                                             <span style={detailLabelStyle}>Event Type:</span>
//                                                                             <span style={detailValueStyle}>{quotation.eventType || '-'}</span>
//                                                                         </div>
//                                                                         <div style={detailRowStyle}>
//                                                                             <span style={detailLabelStyle}>Event Date:</span>
//                                                                             <span style={detailValueStyle}>{formatDate(quotation.eventDate)}</span>
//                                                                         </div>
//                                                                         <div style={detailRowStyle}>
//                                                                             <span style={detailLabelStyle}>Event Time:</span>
//                                                                             <span style={detailValueStyle}>{quotation.eventTime || '-'}</span>
//                                                                         </div>
//                                                                         <div style={detailRowStyle}>
//                                                                             <span style={detailLabelStyle}>Address:</span>
//                                                                             <span style={detailValueStyle}>{quotation.fullAddress || '-'}</span>
//                                                                         </div>
//                                                                         <div style={detailRowStyle}>
//                                                                             <span style={detailLabelStyle}>City:</span>
//                                                                             <span style={detailValueStyle}>{quotation.city || '-'}</span>
//                                                                         </div>
//                                                                     </div>

//                                                                     {/* Payment Details */}
//                                                                     <div style={quotationSectionStyle}>
//                                                                         <h4 style={quotationSectionTitleStyle}>Payment Details</h4>
//                                                                         <div style={detailRowStyle}>
//                                                                             <span style={detailLabelStyle}>Partial Amount:</span>
//                                                                             <span style={detailValueStyle}>{formatCurrency(quotation.partialAmount)}</span>
//                                                                         </div>
//                                                                         <div style={detailRowStyle}>
//                                                                             <span style={detailLabelStyle}>Remaining Amount:</span>
//                                                                             <span style={{ ...detailValueStyle, fontWeight: 600, color: '#DC2626' }}>
//                                                                                 {formatCurrency(quotation.remainingAmount)}
//                                                                             </span>
//                                                                         </div>
//                                                                         <div style={detailRowStyle}>
//                                                                             <span style={detailLabelStyle}>CGST:</span>
//                                                                             <span style={detailValueStyle}>{formatCurrency(quotation.cgstAmount)}</span>
//                                                                         </div>
//                                                                         <div style={detailRowStyle}>
//                                                                             <span style={detailLabelStyle}>SGST:</span>
//                                                                             <span style={detailValueStyle}>{formatCurrency(quotation.sgstAmount)}</span>
//                                                                         </div>
//                                                                         {quotation.quotationDetails && (
//                                                                             <div style={detailRowStyle}>
//                                                                                 <span style={detailLabelStyle}>Details:</span>
//                                                                                 <span style={detailValueStyle}>{quotation.quotationDetails}</span>
//                                                                             </div>
//                                                                         )}
//                                                                     </div>
//                                                                 </div>
//                                                             </div>
//                                                         )}
//                                                     </div>
//                                                 ))}
//                                             </div>
//                                         )}
//                                     </div>
//                                 )}
//                             </div>
//                         );
//                     })
//                 )}
//             </div>

//             <style>{`
//                 @keyframes spin { to { transform: rotate(360deg); } }
//                 @keyframes fadeIn {
//                     from { opacity: 0; transform: translateY(-10px); }
//                     to { opacity: 1; transform: translateY(0); }
//                 }
//                 @keyframes slideDown {
//                     from { opacity: 0; transform: translateY(-10px); }
//                     to { opacity: 1; transform: translateY(0); }
//                 }
//             `}</style>
//         </div>
//     );
// };

// // ─── Styles ──────────────────────────────────────────────────────

// const containerStyle = {
//     padding: '4px 0',
//     fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
// };

// const headerStyle = {
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     marginBottom: '24px',
//     flexWrap: 'wrap',
//     gap: '16px',
// };

// const headerLeftStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '16px',
// };

// const headerIconStyle = {
//     width: '44px',
//     height: '44px',
//     background: 'linear-gradient(135deg, #e66d33, #e66d33)',
//     borderRadius: '12px',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     color: '#fff',
// };

// const titleStyle = {
//     fontSize: '24px',
//     fontWeight: 700,
//     color: '#111827',
//     margin: 0,
//     letterSpacing: '-0.5px',
// };

// const subtitleStyle = {
//     fontSize: '14px',
//     color: '#6B7280',
//     margin: '4px 0 0 0',
// };

// // Stats Styles
// const statsContainerStyle = {
//     display: 'grid',
//     gridTemplateColumns: 'repeat(3, 1fr)',
//     gap: '16px',
//     marginBottom: '20px',
// };

// const statCardStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '16px',
//     background: '#fff',
//     padding: '18px 20px',
//     borderRadius: '12px',
//     boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
//     border: '1px solid #E5E7EB',
//     transition: 'all 0.2s ease',
// };

// const statIconWrapperStyle = {
//     width: '44px',
//     height: '44px',
//     borderRadius: '10px',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
// };

// const statNumberStyle = {
//     fontSize: '22px',
//     fontWeight: 700,
//     color: '#111827',
//     lineHeight: 1.2,
// };

// const statLabelStyle = {
//     fontSize: '13px',
//     color: '#6B7280',
//     fontWeight: 500,
// };

// // Search Styles
// const searchFilterContainerStyle = {
//     display: 'flex',
//     gap: '12px',
//     marginBottom: '20px',
//     flexWrap: 'wrap',
//     alignItems: 'center',
// };

// const searchContainerStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     flex: 1,
//     minWidth: '200px',
//     background: '#fff',
//     border: '1px solid #E5E7EB',
//     borderRadius: '10px',
//     padding: '0 16px',
//     transition: 'all 0.2s ease',
// };

// const searchIconStyle = {
//     color: '#9CA3AF',
//     marginRight: '12px',
// };

// const searchInputStyle = {
//     flex: 1,
//     padding: '11px 0',
//     border: 'none',
//     outline: 'none',
//     fontSize: '14px',
//     background: 'transparent',
//     color: '#111827',
// };

// const clearSearchButtonStyle = {
//     background: 'none',
//     border: 'none',
//     cursor: 'pointer',
//     color: '#9CA3AF',
//     padding: '4px 8px',
//     borderRadius: '4px',
//     transition: 'all 0.2s ease',
// };

// const resultCountStyle = {
//     fontSize: '13px',
//     color: '#6B7280',
//     fontWeight: 500,
// };

// // Cards Container - FIXED: Auto height with overflow scroll
// const cardsContainerStyle = {
//     display: 'flex',
//     flexDirection: 'column',
//     gap: '12px',
//     maxHeight: 'calc(100vh - 380px)',
//     overflowY: 'auto',
//     paddingRight: '4px',
// };

// // Card Wrapper - Each card independent
// const cardWrapperStyle = {
//     flexShrink: 0, // Prevents card from shrinking
// };

// // Card Styles
// const cardStyle = {
//     background: '#fff',
//     borderRadius: '12px',
//     border: '1px solid #E5E7EB',
//     boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
//     transition: 'all 0.2s ease',
//     overflow: 'hidden',
// };

// const cardHeaderStyle = {
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     padding: '16px 20px',
//     cursor: 'pointer',
//     transition: 'all 0.2s ease',
//     borderBottom: '1px solid transparent',
//     backgroundColor: '#fff',
// };

// const cardHeaderLeftStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '14px',
//     flex: 1,
//     minWidth: 0,
// };

// const avatarStyle = {
//     width: '40px',
//     height: '40px',
//     borderRadius: '50%',
//     background: 'linear-gradient(135deg, #e66d33, #d45a2a)',
//     color: '#fff',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     fontSize: '16px',
//     fontWeight: 600,
//     flexShrink: 0,
// };

// const customerNameStyle = {
//     fontSize: '15px',
//     fontWeight: 600,
//     color: '#111827',
// };

// const customerDetailStyle = {
//     fontSize: '13px',
//     color: '#6B7280',
// };

// const cardHeaderRightStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '16px',
//     flexShrink: 0,
// };

// const amountStyle = {
//     fontSize: '16px',
//     fontWeight: 700,
//     color: '#059669',
// };

// const expandIconStyle = {
//     color: '#9CA3AF',
//     transition: 'transform 0.2s ease',
// };

// // Card Body - Expanded
// const cardBodyStyle = {
//     padding: '20px',
//     borderTop: '1px solid #E5E7EB',
//     animation: 'slideDown 0.3s ease',
//     backgroundColor: '#FAFBFC',
// };

// // Loading Quotations
// const loadingQuotationsStyle = {
//     display: 'flex',
//     flexDirection: 'column',
//     alignItems: 'center',
//     gap: '12px',
//     padding: '30px 20px',
//     color: '#6B7280',
// };

// const noQuotationsStyle = {
//     textAlign: 'center',
//     padding: '30px 20px',
//     color: '#9CA3AF',
//     fontSize: '14px',
// };

// // Quotations List
// const quotationsListStyle = {
//     display: 'flex',
//     flexDirection: 'column',
//     gap: '10px',
// };

// // Quotation Card
// const quotationCardStyle = {
//     background: '#FFFFFF',
//     borderRadius: '10px',
//     border: '1px solid #E5E7EB',
//     overflow: 'hidden',
//     transition: 'all 0.2s ease',
// };

// const quotationHeaderStyle = {
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     padding: '12px 16px',
//     cursor: 'pointer',
//     transition: 'all 0.2s ease',
//     backgroundColor: '#fff',
// };

// const quotationHeaderLeftStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '12px',
//     flex: 1,
//     minWidth: 0,
// };

// const vendorIconStyle = {
//     width: '32px',
//     height: '32px',
//     borderRadius: '50%',
//     background: '#EEF2FF',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     color: '#4F46E5',
// };

// const vendorNameStyle = {
//     fontSize: '14px',
//     fontWeight: 600,
//     color: '#111827',
// };

// const quotationMetaStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '8px',
//     marginTop: '2px',
//     flexWrap: 'wrap',
// };

// const quotationDateStyle = {
//     fontSize: '11px',
//     color: '#9CA3AF',
// };

// const quotationHeaderRightStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '12px',
//     flexShrink: 0,
// };

// const quotedAmountStyle = {
//     fontSize: '15px',
//     fontWeight: 700,
//     color: '#059669',
// };

// // Quotation Detail
// const quotationDetailStyle = {
//     padding: '16px',
//     borderTop: '1px solid #E5E7EB',
//     animation: 'slideDown 0.3s ease',
//     backgroundColor: '#F8FAFC',
// };

// const quotationGridStyle = {
//     display: 'grid',
//     gridTemplateColumns: 'repeat(4, 1fr)',
//     gap: '16px',
// };

// const quotationSectionStyle = {
//     display: 'flex',
//     flexDirection: 'column',
//     gap: '4px',
// };

// const quotationSectionTitleStyle = {
//     fontSize: '12px',
//     fontWeight: 600,
//     color: '#4B5563',
//     margin: '0 0 4px 0',
//     borderBottom: '1px solid #E5E7EB',
//     paddingBottom: '4px',
// };

// // Detail Row
// const detailRowStyle = {
//     display: 'flex',
//     justifyContent: 'space-between',
//     padding: '2px 0',
//     fontSize: '12px',
// };

// const detailLabelStyle = {
//     color: '#6B7280',
//     fontWeight: 500,
// };

// const detailValueStyle = {
//     color: '#111827',
// };

// // Empty State
// const emptyStateStyle = {
//     padding: '60px 20px',
//     textAlign: 'center',
//     background: '#fff',
//     borderRadius: '12px',
//     border: '1px solid #E5E7EB',
// };

// const emptyStateContentStyle = {
//     display: 'flex',
//     flexDirection: 'column',
//     alignItems: 'center',
//     gap: '8px',
// };

// const emptyStateTextStyle = {
//     fontSize: '16px',
//     fontWeight: 500,
//     color: '#4B5563',
//     margin: '8px 0 0 0',
// };

// const emptyStateSubtextStyle = {
//     fontSize: '13px',
//     color: '#9CA3AF',
// };

// // Loading
// const loadingStyle = {
//     padding: '60px 20px',
//     textAlign: 'center',
//     display: 'flex',
//     flexDirection: 'column',
//     alignItems: 'center',
//     gap: '12px',
//     color: '#6B7280',
// };

// // Responsive Styles
// const responsiveStyles = `
//     @media (max-width: 1024px) {
//         .quotation-grid {
//             grid-template-columns: 1fr 1fr !important;
//         }
//         .stats-container {
//             grid-template-columns: repeat(3, 1fr) !important;
//         }
//     }
//     @media (max-width: 768px) {
//         .stats-container {
//             grid-template-columns: 1fr 1fr !important;
//         }
//         .quotation-grid {
//             grid-template-columns: 1fr !important;
//         }
//         .card-header {
//             flex-wrap: wrap;
//             gap: 8px;
//         }
//         .card-header-right {
//             flex-wrap: wrap;
//             gap: 8px;
//         }
//         .search-filter-container {
//             flex-direction: column;
//         }
//         .search-container {
//             width: 100%;
//         }
//         .quotation-header {
//             flex-wrap: wrap;
//             gap: 8px;
//         }
//         .quotation-header-right {
//             width: 100%;
//             justify-content: space-between;
//         }
//     }
//     @media (max-width: 480px) {
//         .stats-container {
//             grid-template-columns: 1fr !important;
//         }
//         .stat-card {
//             padding: 12px 14px;
//         }
//         .stat-number {
//             font-size: 18px;
//         }
//         .card-header {
//             padding: 12px 16px;
//         }
//         .card-body {
//             padding: 16px;
//         }
//         .customer-name {
//             font-size: 14px;
//         }
//         .amount {
//             font-size: 14px;
//         }
//         .quotation-header {
//             padding: 10px 12px;
//         }
//         .quotation-detail {
//             padding: 12px;
//         }
//         .quotation-grid {
//             grid-template-columns: 1fr !important;
//         }
//     }
// `;

// export default SalseQuotation;



import React, { useState, useEffect } from 'react';
import {
    FaSearch, FaSpinner, FaTimes,
    FaChevronDown, FaChevronUp,
    FaClipboardList, FaCheckCircle, FaClock,
    FaBuilding, FaMapMarkerAlt, FaReceipt
} from 'react-icons/fa';
import { getAllEnquiries } from '../../../Servicefile/salesService';
import axios from 'axios';

const SalseQuotation = () => {
    // ============================================
    // STATE (unchanged)
    // ============================================
    const [enquiries, setEnquiries] = useState([]);
    const [filteredEnquiries, setFilteredEnquiries] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingQuotations, setLoadingQuotations] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [expandedId, setExpandedId] = useState(null);
    const [quotationsMap, setQuotationsMap] = useState({});
    const [expandedQuotation, setExpandedQuotation] = useState(null);
    const [hoveredCard, setHoveredCard] = useState(null);

    // Stats
    const [stats, setStats] = useState({
        total: 0,
        quoted: 0,
        pending: 0
    });

    // ============================================
    // API CALLS (unchanged)
    // ============================================
    const fetchQuotations = async () => {
        setLoading(true);
        try {
            const data = await getAllEnquiries();

            const quotedData = (data || []).filter(enquiry =>
                enquiry.adminId !== null &&
                enquiry.adminId !== undefined &&
                enquiry.leadStatus === 'PAYMENT_RECEIVED'
            );

            const sortedData = quotedData.sort((a, b) => {
                const dateA = new Date(a.createdAt);
                const dateB = new Date(b.createdAt);
                return dateB - dateA;
            });

            setEnquiries(sortedData);
            setFilteredEnquiries(sortedData);
            calculateStats(sortedData);
        } catch (error) {
            console.error('Error fetching quotations:', error);
            alert('Failed to fetch quotations');
        } finally {
            setLoading(false);
        }
    };

    const fetchQuotationsByLeadId = async (leadId) => {
        if (quotationsMap[leadId]) {
            return;
        }

        setLoadingQuotations(true);
        try {
            const token = localStorage.getItem("authToken");
            const response = await axios.get(
                `https://backend.maamaas.com/catering/api/user/lead/quotations/${leadId}/`,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                }
            );

            if (response.data.success) {
                setQuotationsMap(prev => ({
                    ...prev,
                    [leadId]: response.data.data || []
                }));
            } else {
                setQuotationsMap(prev => ({
                    ...prev,
                    [leadId]: []
                }));
            }
        } catch (error) {
            console.error('Error fetching quotations:', error);
            setQuotationsMap(prev => ({
                ...prev,
                [leadId]: []
            }));
        } finally {
            setLoadingQuotations(false);
        }
    };

    // ============================================
    // CALCULATE STATS (unchanged)
    // ============================================
    const calculateStats = (data) => {
        const total = data.length;
        const quoted = data.filter(e => e.leadStatus === 'PAYMENT_RECEIVED').length;
        const pending = data.filter(e => e.leadStatus !== 'PAYMENT_RECEIVED').length;
        setStats({ total, quoted, pending });
    };

    // ============================================
    // FILTER (unchanged)
    // ============================================
    const handleSearch = (e) => {
        const term = e.target.value.toLowerCase();
        setSearchTerm(term);

        if (term.trim() === '') {
            setFilteredEnquiries(enquiries);
        } else {
            const filtered = enquiries.filter(enquiry =>
                (enquiry.fullName || '').toLowerCase().includes(term) ||
                (enquiry.email || '').toLowerCase().includes(term) ||
                (enquiry.companyName || '').toLowerCase().includes(term) ||
                (enquiry.city || '').toLowerCase().includes(term) ||
                (enquiry.enquiryId || enquiry.id || '').toString().includes(term)
            );
            setFilteredEnquiries(filtered);
        }
    };

    const clearSearch = () => {
        setSearchTerm('');
        setFilteredEnquiries(enquiries);
    };

    // ============================================
    // TOGGLE EXPAND (unchanged)
    // ============================================
    const toggleExpand = (leadId) => {
        if (expandedId === leadId) {
            setExpandedId(null);
            setExpandedQuotation(null);
        } else {
            setExpandedId(leadId);
            setExpandedQuotation(null);
            fetchQuotationsByLeadId(leadId);
        }
    };

    const toggleQuotationExpand = (quotationId) => {
        setExpandedQuotation(expandedQuotation === quotationId ? null : quotationId);
    };

    // ============================================
    // FORMAT HELPERS (unchanged)
    // ============================================
    const formatDate = (dateStr) => {
        if (!dateStr) return '-';
        try {
            const date = new Date(dateStr);
            return date.toLocaleDateString('en-IN', {
                day: '2-digit',
                month: 'short',
                year: 'numeric'
            });
        } catch {
            return dateStr;
        }
    };

    const formatCurrency = (amount) => {
        if (!amount) return '₹0';
        return `₹${Number(amount).toLocaleString('en-IN')}`;
    };

    const getStatusBadge = (status) => {
        if (status === 'PAYMENT_RECEIVED') {
            return (
                <span style={{ ...badgeBaseStyle, background: '#E8F5EC', color: '#1E7A3D' }}>
                    <FaCheckCircle size={11} /> Quoted
                </span>
            );
        }
        return (
            <span style={{ ...badgeBaseStyle, background: '#FDF1E1', color: '#B5720F' }}>
                <FaClock size={11} /> Pending
            </span>
        );
    };

    const getQuotationStatusBadge = (status) => {
        const statusMap = {
            'SUBMITTED': { bg: '#E4EEFB', color: '#20579B', label: 'Submitted' },
            'APPROVED': { bg: '#E8F5EC', color: '#1E7A3D', label: 'Approved' },
            'REJECTED': { bg: '#FBEAE7', color: '#B5402C', label: 'Rejected' },
            'PENDING': { bg: '#FDF1E1', color: '#B5720F', label: 'Pending' }
        };
        const info = statusMap[status] || statusMap['PENDING'];
        return (
            <span style={{
                display: 'inline-flex',
                alignItems: 'center',
                padding: '3px 10px',
                borderRadius: '20px',
                fontSize: '11px',
                fontWeight: 600,
                letterSpacing: '0.2px',
                background: info.bg,
                color: info.color
            }}>
                {info.label}
            </span>
        );
    };

    // ============================================
    // EFFECTS (unchanged)
    // ============================================
    useEffect(() => {
        fetchQuotations();
    }, []);

    // ============================================
    // RENDER
    // ============================================
    return (
        <div style={containerStyle}>
            <style>{globalCss}</style>

          

            {/* Stats Cards */}
            <div className="stats-container" style={statsContainerStyle}>
                <div className="stat-card" style={statCardStyle}>
                    <div style={{ ...statIconWrapperStyle, background: '#FBEDE4', color: '#C1552A' }}>
                        <FaClipboardList size={18} />
                    </div>
                    <div>
                        <div className="stat-number" style={statNumberStyle}>{stats.total}</div>
                        <div style={statLabelStyle}>Total Quoted</div>
                    </div>
                </div>
                <div className="stat-card" style={statCardStyle}>
                    <div style={{ ...statIconWrapperStyle, background: '#E8F5EC', color: '#1E7A3D' }}>
                        <FaCheckCircle size={18} />
                    </div>
                    <div>
                        <div className="stat-number" style={statNumberStyle}>{stats.quoted}</div>
                        <div style={statLabelStyle}>Quoted</div>
                    </div>
                </div>
                <div className="stat-card" style={statCardStyle}>
                    <div style={{ ...statIconWrapperStyle, background: '#FDF1E1', color: '#B5720F' }}>
                        <FaClock size={18} />
                    </div>
                    <div>
                        <div className="stat-number" style={statNumberStyle}>{stats.pending}</div>
                        <div style={statLabelStyle}>Pending</div>
                    </div>
                </div>
            </div>

            {/* Search */}
            <div className="search-filter-container" style={searchFilterContainerStyle}>
                <div className="search-container" style={searchContainerStyle}>
                    <FaSearch style={searchIconStyle} size={14} />
                    <input
                        type="text"
                        placeholder="Search by name, email, company, city..."
                        value={searchTerm}
                        onChange={handleSearch}
                        style={searchInputStyle}
                    />
                    {searchTerm && (
                        <button onClick={clearSearch} style={clearSearchButtonStyle}>
                            <FaTimes size={13} />
                        </button>
                    )}
                </div>
                <div style={resultCountStyle}>
                    {filteredEnquiries.length} result{filteredEnquiries.length !== 1 && 's'}
                </div>
            </div>

            {/* Lead Cards */}
            <div style={cardsContainerStyle}>
                {loading ? (
                    <div style={loadingStyle}>
                        <FaSpinner className="spin" size={28} color="#C1552A" />
                        <p>Loading quotations...</p>
                    </div>
                ) : filteredEnquiries.length === 0 ? (
                    <div style={emptyStateStyle}>
                        <div style={emptyStateContentStyle}>
                            <FaClipboardList size={40} color="#D9CFC2" />
                            <p style={emptyStateTextStyle}>No quotations found</p>
                            <span style={emptyStateSubtextStyle}>
                                {searchTerm ? 'Try adjusting your search terms' : 'No enquiries with quotations available'}
                            </span>
                        </div>
                    </div>
                ) : (
                    filteredEnquiries.map((enquiry) => {
                        const leadId = enquiry.id || enquiry.enquiryId;
                        const isExpanded = expandedId === leadId;
                        const leadQuotations = quotationsMap[leadId] || [];
                        const isLoadingQuotations = loadingQuotations && isExpanded && !quotationsMap[leadId];

                        return (
                            <div key={leadId} style={cardWrapperStyle}>
                                <div
                                    style={{
                                        ...cardOuterStyle,
                                        borderColor: isExpanded ? '#E9A277' : '#EDE6DB',
                                        boxShadow: isExpanded
                                            ? '0 8px 24px rgba(198, 106, 55, 0.12)'
                                            : hoveredCard === leadId
                                                ? '0 4px 14px rgba(31, 22, 15, 0.07)'
                                                : '0 1px 2px rgba(31, 22, 15, 0.04)'
                                    }}
                                    onMouseEnter={() => setHoveredCard(leadId)}
                                    onMouseLeave={() => setHoveredCard(null)}
                                >
                                    {/* Card Header */}
                                    <div
                                        className="card-header"
                                        style={cardHeaderStyle}
                                        onClick={() => toggleExpand(leadId)}
                                    >
                                        <div style={{ ...leadAccentStyle, background: enquiry.leadStatus === 'PAYMENT_RECEIVED' ? '#2F9E5B' : '#E0972B' }} />
                                        <div style={cardHeaderLeftStyle}>
                                            <div style={avatarStyle}>
                                                {(enquiry.fullName || '?')[0].toUpperCase()}
                                            </div>
                                            <div style={{ minWidth: 0 }}>
                                                <div className="customer-name" style={customerNameStyle}>{enquiry.fullName || 'Unknown'}</div>
                                                <div style={customerDetailStyle}>
                                                    {enquiry.companyName || 'No company'}
                                                    <span style={dotSeparatorStyle}>•</span>
                                                    <FaMapMarkerAlt size={10} style={{ marginRight: '3px', opacity: 0.6 }} />
                                                    {enquiry.city || 'No city'}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-header-right" style={cardHeaderRightStyle}>
                                            <div className="amount" style={amountStyle}>{formatCurrency(enquiry.budget)}</div>
                                            {getStatusBadge(enquiry.leadStatus)}
                                            <div style={{ ...expandIconStyle, transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)' }}>
                                                <FaChevronDown size={13} />
                                            </div>
                                        </div>
                                    </div>

                                    {/* Card Body */}
                                    {isExpanded && (
                                        <div className="card-body" style={cardBodyStyle}>
                                            <div style={bodyLabelStyle}>Vendor Bids</div>
                                            {isLoadingQuotations ? (
                                                <div style={loadingQuotationsStyle}>
                                                    <FaSpinner className="spin" size={22} color="#C1552A" />
                                                    <p>Fetching vendor quotations...</p>
                                                </div>
                                            ) : leadQuotations.length === 0 ? (
                                                <div style={noQuotationsStyle}>
                                                    No quotations submitted for this lead yet
                                                </div>
                                            ) : (
                                                <div style={quotationsListStyle}>
                                                    {leadQuotations.map((quotation, index) => {
                                                        const qId = quotation.quotationId || index;
                                                        const qExpanded = expandedQuotation === qId;
                                                        return (
                                                            <div key={qId} style={{
                                                                ...quotationCardStyle,
                                                                borderColor: qExpanded ? '#E9A277' : '#EDE6DB'
                                                            }}>
                                                                <div
                                                                    className="quotation-header"
                                                                    style={quotationHeaderStyle}
                                                                    onClick={() => toggleQuotationExpand(qId)}
                                                                >
                                                                    <div style={quotationHeaderLeftStyle}>
                                                                        <div style={vendorIconStyle}>
                                                                            <FaBuilding size={14} />
                                                                        </div>
                                                                        <div>
                                                                            <div style={vendorNameStyle}>{quotation.vendorName || 'Unknown Vendor'}</div>
                                                                            <div style={quotationMetaStyle}>
                                                                                {getQuotationStatusBadge(quotation.status)}
                                                                                <span style={quotationDateStyle}>
                                                                                    {formatDate(quotation.createdAt)}
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="quotation-header-right" style={quotationHeaderRightStyle}>
                                                                        <div style={quotedAmountStyle}>{formatCurrency(quotation.quotedAmount)}</div>
                                                                        <div style={{ ...expandIconStyle, transform: qExpanded ? 'rotate(180deg)' : 'rotate(0deg)' }}>
                                                                            <FaChevronDown size={12} />
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                {/* Quotation Detail — invoice-styled panel */}
                                                                {qExpanded && (
                                                                    <div style={quotationDetailWrapStyle}>
                                                                        <div style={perforationStyle}>
                                                                            {Array.from({ length: 40 }).map((_, i) => (
                                                                                <span key={i} style={perfDotStyle} />
                                                                            ))}
                                                                        </div>
                                                                        <div className="quotation-grid" style={quotationGridStyle}>
                                                                            <InvoiceSection title="Pricing">
                                                                                <DetailRow label="Base amount" value={formatCurrency(quotation.baseAmount)} />
                                                                                <DetailRow label="Veg / plate" value={formatCurrency(quotation.vegPerPlatePrice)} />
                                                                                <DetailRow label="Non-veg / plate" value={formatCurrency(quotation.nonVegPerPlatePrice)} />
                                                                                <DetailRow label="Mixed / plate" value={formatCurrency(quotation.mixedPerPlatePrice)} />
                                                                                <DetailRow label="Total plates" value={quotation.totalPlates} />
                                                                                <DetailRow label="Platform fee" value={formatCurrency(quotation.platformFee)} />
                                                                                <DetailRow label="Delivery fee" value={formatCurrency(quotation.deliveryFee)} />
                                                                            </InvoiceSection>

                                                                            <InvoiceSection title="Vendor">
                                                                                <DetailRow label="Name" value={quotation.vendorName || '-'} />
                                                                                <DetailRow label="City" value={quotation.vendorCity || '-'} />
                                                                                <DetailRow label="State" value={quotation.vendorState || '-'} />
                                                                                <DetailRow label="Address" value={quotation.vendorFullAddress || '-'} />
                                                                                <DetailRow label="Distance" value={quotation.distanceInKm ? `${quotation.distanceInKm} km` : '-'} />
                                                                            </InvoiceSection>

                                                                            <InvoiceSection title="Event">
                                                                                <DetailRow label="Event" value={quotation.event || '-'} />
                                                                                <DetailRow label="Type" value={quotation.eventType || '-'} />
                                                                                <DetailRow label="Date" value={formatDate(quotation.eventDate)} />
                                                                                <DetailRow label="Time" value={quotation.eventTime || '-'} />
                                                                                <DetailRow label="Address" value={quotation.fullAddress || '-'} />
                                                                                <DetailRow label="City" value={quotation.city || '-'} />
                                                                            </InvoiceSection>

                                                                            <InvoiceSection title="Payment">
                                                                                <DetailRow label="Partial paid" value={formatCurrency(quotation.partialAmount)} />
                                                                                <DetailRow label="Remaining" value={formatCurrency(quotation.remainingAmount)} highlight="danger" />
                                                                                <DetailRow label="CGST" value={formatCurrency(quotation.cgstAmount)} />
                                                                                <DetailRow label="SGST" value={formatCurrency(quotation.sgstAmount)} />
                                                                                {quotation.quotationDetails && (
                                                                                    <DetailRow label="Notes" value={quotation.quotationDetails} />
                                                                                )}
                                                                            </InvoiceSection>
                                                                        </div>

                                                                        <div style={grandTotalBarStyle}>
                                                                            <span style={grandTotalLabelStyle}>Grand Total</span>
                                                                            <span style={grandTotalValueStyle}>{formatCurrency(quotation.grandTotal)}</span>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        );
                    })
                )}
            </div>
        </div>
    );
};

// ─── Small subcomponents ──────────────────────────────────────────

const InvoiceSection = ({ title, children }) => (
    <div style={quotationSectionStyle}>
        <h4 style={quotationSectionTitleStyle}>{title}</h4>
        {children}
    </div>
);

const DetailRow = ({ label, value, highlight }) => (
    <div style={detailRowStyle}>
        <span style={detailLabelStyle}>{label}</span>
        <span style={{
            ...detailValueStyle,
            color: highlight === 'danger' ? '#B5402C' : detailValueStyle.color,
            fontWeight: highlight === 'danger' ? 700 : detailValueStyle.fontWeight
        }}>{value}</span>
    </div>
);

// ─── Global CSS: keyframes + responsive rules ─────────────────────

const globalCss = `
    @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@600;700&family=Inter:wght@400;500;600;700&display=swap');

    .spin { animation: sq-spin 1s linear infinite; }
    @keyframes sq-spin { to { transform: rotate(360deg); } }
    @keyframes sq-slideDown {
        from { opacity: 0; transform: translateY(-6px); }
        to { opacity: 1; transform: translateY(0); }
    }

    @media (max-width: 900px) {
        .stats-container { grid-template-columns: repeat(3, 1fr) !important; gap: 10px !important; }
        .quotation-grid { grid-template-columns: 1fr 1fr !important; }
    }
    @media (max-width: 680px) {
        .stats-container { grid-template-columns: 1fr 1fr !important; }
        .quotation-grid { grid-template-columns: 1fr !important; }
        .search-filter-container { flex-direction: column; align-items: stretch !important; }
        .card-header { flex-wrap: wrap; gap: 10px; }
        .card-header-right { width: 100%; justify-content: space-between !important; }
        .quotation-header { flex-wrap: wrap; gap: 8px; }
        .quotation-header-right { width: 100%; justify-content: space-between !important; }
    }
    @media (max-width: 420px) {
        .stats-container { grid-template-columns: 1fr !important; }
        .customer-name { font-size: 14px !important; }
        .amount { font-size: 14px !important; }
    }
`;

// ─── Styles ──────────────────────────────────────────────────────

const containerStyle = {
    padding: '4px 2px',
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
    color: '#241C15',
};

const headerStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '22px',
    flexWrap: 'wrap',
    gap: '16px',
};

const headerLeftStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '14px',
};

const headerIconStyle = {
    width: '46px',
    height: '46px',
    background: 'linear-gradient(135deg, #E66D33, #C1552A)',
    borderRadius: '14px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
    boxShadow: '0 6px 14px rgba(198, 106, 55, 0.28)',
    flexShrink: 0,
};

const titleStyle = {
    fontFamily: "'Poppins', 'Inter', sans-serif",
    fontSize: '22px',
    fontWeight: 700,
    color: '#241C15',
    margin: 0,
    letterSpacing: '-0.3px',
};

const subtitleStyle = {
    fontSize: '13px',
    color: '#8C7F6E',
    margin: '3px 0 0 0',
};

// Stats
const statsContainerStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '14px',
    marginBottom: '18px',
};

const statCardStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '14px',
    background: '#fff',
    padding: '16px 18px',
    borderRadius: '14px',
    border: '1px solid #EDE6DB',
    boxShadow: '0 1px 2px rgba(31,22,15,0.04)',
};

const statIconWrapperStyle = {
    width: '40px',
    height: '40px',
    borderRadius: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
};

const statNumberStyle = {
    fontFamily: "'Poppins', 'Inter', sans-serif",
    fontSize: '20px',
    fontWeight: 700,
    color: '#241C15',
    lineHeight: 1.2,
};

const statLabelStyle = {
    fontSize: '12px',
    color: '#8C7F6E',
    fontWeight: 500,
    marginTop: '1px',
};

// Search
const searchFilterContainerStyle = {
    display: 'flex',
    gap: '12px',
    marginBottom: '18px',
    flexWrap: 'wrap',
    alignItems: 'center',
};

const searchContainerStyle = {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    minWidth: '220px',
    background: '#fff',
    border: '1px solid #EDE6DB',
    borderRadius: '11px',
    padding: '0 14px',
};

const searchIconStyle = {
    color: '#B5A996',
    marginRight: '10px',
    flexShrink: 0,
};

const searchInputStyle = {
    flex: 1,
    padding: '10px 0',
    border: 'none',
    outline: 'none',
    fontSize: '14px',
    background: 'transparent',
    color: '#241C15',
    fontFamily: "'Inter', sans-serif",
};

const clearSearchButtonStyle = {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    color: '#B5A996',
    padding: '4px 6px',
    borderRadius: '6px',
};

const resultCountStyle = {
    fontSize: '12.5px',
    color: '#8C7F6E',
    fontWeight: 500,
    whiteSpace: 'nowrap',
};

// Cards container
const cardsContainerStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    maxHeight: 'calc(100vh - 360px)',
    // overflowY: 'auto',
    paddingRight: '4px',
};

const cardWrapperStyle = {
    flexShrink: 0,
};

const cardOuterStyle = {
    background: '#fff',
    borderRadius: '14px',
    border: '1px solid #EDE6DB',
    overflow: 'hidden',
    transition: 'box-shadow 0.2s ease, border-color 0.2s ease',
};

const cardHeaderStyle = {
    display: 'flex',
    alignItems: 'center',
    padding: '14px 18px 14px 0',
    cursor: 'pointer',
    gap: '14px',
};

const leadAccentStyle = {
    width: '4px',
    alignSelf: 'stretch',
    borderRadius: '0 4px 4px 0',
    minHeight: '44px',
};

const cardHeaderLeftStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '13px',
    flex: 1,
    minWidth: 0,
};

const avatarStyle = {
    width: '38px',
    height: '38px',
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #E66D33, #C1552A)',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '15px',
    fontWeight: 700,
    flexShrink: 0,
    fontFamily: "'Poppins', sans-serif",
};

const customerNameStyle = {
    fontSize: '14.5px',
    fontWeight: 600,
    color: '#241C15',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
};

const customerDetailStyle = {
    fontSize: '12.5px',
    color: '#8C7F6E',
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    marginTop: '2px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
};

const dotSeparatorStyle = {
    margin: '0 2px',
    color: '#D9CFC2',
};

const cardHeaderRightStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '14px',
    flexShrink: 0,
};

const amountStyle = {
    fontFamily: "'Poppins', sans-serif",
    fontSize: '15px',
    fontWeight: 700,
    color: '#1E7A3D',
};

const badgeBaseStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    padding: '4px 11px',
    borderRadius: '20px',
    fontSize: '11px',
    fontWeight: 600,
};

const expandIconStyle = {
    color: '#B5A996',
    transition: 'transform 0.25s ease',
    display: 'flex',
};

// Card body
const cardBodyStyle = {
    padding: '4px 18px 18px 22px',
    borderTop: '1px solid #F1EBE1',
    background: '#FDFBF8',
    animation: 'sq-slideDown 0.25s ease',
};

const bodyLabelStyle = {
    fontSize: '11px',
    fontWeight: 700,
    color: '#B5A996',
    textTransform: 'uppercase',
    letterSpacing: '0.6px',
    margin: '14px 0 10px 0',
};

const loadingQuotationsStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '10px',
    padding: '26px 20px',
    color: '#8C7F6E',
    fontSize: '13px',
};

const noQuotationsStyle = {
    textAlign: 'center',
    padding: '24px 20px',
    color: '#B5A996',
    fontSize: '13px',
    background: '#fff',
    borderRadius: '10px',
    border: '1px dashed #EDE6DB',
};

const quotationsListStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '9px',
};

const quotationCardStyle = {
    background: '#FFFFFF',
    borderRadius: '11px',
    border: '1px solid #EDE6DB',
    overflow: 'hidden',
    transition: 'border-color 0.2s ease',
};

const quotationHeaderStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '11px 14px',
    cursor: 'pointer',
};

const quotationHeaderLeftStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '11px',
    flex: 1,
    minWidth: 0,
};

const vendorIconStyle = {
    width: '30px',
    height: '30px',
    borderRadius: '9px',
    background: '#FBEDE4',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#C1552A',
    flexShrink: 0,
};

const vendorNameStyle = {
    fontSize: '13.5px',
    fontWeight: 600,
    color: '#241C15',
};

const quotationMetaStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginTop: '3px',
    flexWrap: 'wrap',
};

const quotationDateStyle = {
    fontSize: '11px',
    color: '#B5A996',
};

const quotationHeaderRightStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    flexShrink: 0,
};

const quotedAmountStyle = {
    fontFamily: "'Poppins', sans-serif",
    fontSize: '14px',
    fontWeight: 700,
    color: '#1E7A3D',
};

// Invoice-styled detail panel — the signature element
const quotationDetailWrapStyle = {
    borderTop: '1px solid #F1EBE1',
    background: '#FCFAF6',
    animation: 'sq-slideDown 0.25s ease',
};

const perforationStyle = {
    display: 'flex',
    gap: '5px',
    padding: '8px 14px 0 14px',
    overflow: 'hidden',
};

const perfDotStyle = {
    width: '4px',
    height: '4px',
    borderRadius: '50%',
    background: '#E9DFCF',
    flexShrink: 0,
};

const quotationGridStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: '18px',
    padding: '14px 18px',
};

const quotationSectionStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
};

const quotationSectionTitleStyle = {
    fontSize: '11px',
    fontWeight: 700,
    color: '#C1552A',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    margin: '0 0 5px 0',
    paddingBottom: '5px',
    borderBottom: '1px dashed #E9DFCF',
};

const detailRowStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '10px',
    padding: '1.5px 0',
    fontSize: '12px',
};

const detailLabelStyle = {
    color: '#8C7F6E',
    fontWeight: 500,
    flexShrink: 0,
};

const detailValueStyle = {
    color: '#241C15',
    fontFamily: "'Inter', monospace",
    textAlign: 'right',
};

const grandTotalBarStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '0 14px 14px 14px',
    padding: '10px 16px',
    background: 'linear-gradient(135deg, #241C15, #3A2E22)',
    borderRadius: '10px',
};

const grandTotalLabelStyle = {
    fontSize: '11.5px',
    fontWeight: 600,
    color: '#D9CFC2',
    textTransform: 'uppercase',
    letterSpacing: '0.6px',
};

const grandTotalValueStyle = {
    fontFamily: "'Poppins', sans-serif",
    fontSize: '16px',
    fontWeight: 700,
    color: '#FFB784',
};

// Empty state
const emptyStateStyle = {
    padding: '54px 20px',
    textAlign: 'center',
    background: '#fff',
    borderRadius: '14px',
    border: '1px solid #EDE6DB',
};

const emptyStateContentStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '8px',
};

const emptyStateTextStyle = {
    fontSize: '15px',
    fontWeight: 600,
    color: '#3A2E22',
    margin: '6px 0 0 0',
};

const emptyStateSubtextStyle = {
    fontSize: '12.5px',
    color: '#B5A996',
};

// Loading
const loadingStyle = {
    padding: '54px 20px',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '12px',
    color: '#8C7F6E',
    fontSize: '13px',
};

export default SalseQuotation;